module.exports = __webpack_public_path__ + "static/img/21.a950812f.png";